module.exports = "\n<html lang=\"en\">\n<head>\n    <meta charset=\"UTF-8\">\n    <title>Download IFair</title>\n</head>\n<body>\n</body>\n</html>"